export const OracleRds = {
    engine: (rdsEngineType) => `api/aws/lookups/1.0/aws-rds-engines?rdsEngineType=${rdsEngineType}`,
    instanceTypes: (payload) => `api/aws/lookups/1.0/aws-rds-instance-types?region=${payload?.region}&databaseEngine=${payload?.databaseEngine}`,
    instanceName: 'api/ri/resource/name/aws/1.0/preview/generate-resource-name',
    storageTypes: (awsRdsType) => `api/aws/lookups/1.0/rds/storage-type?awsRdsType=${awsRdsType}`,
};
export default OracleRds;
